import {ActiveAndPastJobDetailsTypes} from '../ActionTypes/ActiveAndPastJobDetailsTypes';

class ActiveAndPastJobDetailsActions {
  static getActiveAndPastJobDetails = payload => {
    return {
      type: ActiveAndPastJobDetailsTypes.GET_ACTIVE_PAST_JOB_DETAILS,
      payload: payload,
    };
  };
}

export default ActiveAndPastJobDetailsActions;
